/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Media_SocialInputs */



/**
* | output |
* | --- |
* | "Social" |
*
* @param {Community_Media_SocialInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_media_social = /** @type {((inputs?: Community_Media_SocialInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Media_SocialInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Social")
	if (locale === "es") return /** @type {LocalizedString} */ ("Social")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Social")
	if (locale === "it") return /** @type {LocalizedString} */ ("Social")
	return /** @type {LocalizedString} */ ("Social")
});